// extracted by css-extract-rspack-plugin
export default {"root":"root-moVGXr","frameworkTabsContainer":"frameworkTabsContainer-qPMUUC","frameworkTabs":"frameworkTabs-TVnQDf","iframeContainer":"iframeContainer-BRVeZh"};